export function rgb8ToUnit(c) {
    return { r: c.r / 255, g: c.g / 255, b: c.b / 255 };
}
export function unitToRgb8(c) {
    return { r: quantizeChannel(c.r), g: quantizeChannel(c.g), b: quantizeChannel(c.b) };
}
function quantizeChannel(x) {
    return Math.min(255, Math.max(0, Math.round(x * 255)));
}
/** Gamma-encoded sRGB channel (0-1) to linear light (0-1). */
export function srgbChannelToLinear(x) {
    return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
/** Linear light channel (0-1) to gamma-encoded sRGB (0-1). */
export function linearChannelToSrgb(x) {
    return x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
}
export function rgbUnitToLinear(c) {
    return {
        r: srgbChannelToLinear(c.r),
        g: srgbChannelToLinear(c.g),
        b: srgbChannelToLinear(c.b),
    };
}
export function linearToRgbUnit(c) {
    return {
        r: linearChannelToSrgb(c.r),
        g: linearChannelToSrgb(c.g),
        b: linearChannelToSrgb(c.b),
    };
}
/** Whether a unit-scale sRGB triple is within gamut without clipping. */
export function isInSrgbGamut(c, eps = 1e-6) {
    return (c.r >= -eps && c.r <= 1 + eps && c.g >= -eps && c.g <= 1 + eps && c.b >= -eps && c.b <= 1 + eps);
}
export function rgb8ToHex(c) {
    const toHex = (v) => v.toString(16).padStart(2, "0");
    return `#${toHex(c.r)}${toHex(c.g)}${toHex(c.b)}`;
}
//# sourceMappingURL=srgb.js.map